"use client";

import { memo } from "react";
import Image from "next/image";
import Link from "next/link";
import ModalCloseIcon from "@/assets/icons/modal-close.svg";

interface ThreadShareHeaderProps {
  onClose: () => void;
}

export const ThreadShareHeader = memo(function ThreadShareHeader(
  props: ThreadShareHeaderProps
) {
  const { onClose } = props;

  return (
    <div className="relative mx-auto flex h-[60px] max-w-[1600px] items-center justify-between px-5">
      <Link href="/">
        <div className="flex items-center gap-2">
          <Image src="/logo.png" alt="VidMuse" width={24} height={24} />
          <span className="text-xl font-bold text-black">VidMuse</span>
        </div>
      </Link>

      <button
        type="button"
        className="cursor-pointer border-0 bg-transparent p-0"
        onClick={onClose}
        aria-label="Close thread showcase"
      >
        <ModalCloseIcon className="h-5 w-5 text-[#98A2B3]" />
      </button>
    </div>
  );
});
